module.exports = __webpack_public_path__ + "static/img/bg-es.cd4800b0.png";